define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/storage",
	"csi/action/Switchboard",
	"csi/datasheet/Widget",
	"csi/def/Action",
	"csi/def/Toolbar",
	"csi/session",
	"csi/state",
	"csi/state/rootStore",
	"csi/store/Nodes",
	"csi/xml",
	"csi/xml/Query",
	"lodash",
	"./CareAndCompositionProductSalesRegionSwitchboard"
], function (declare, lang, csi, storage, SwitchboardAction, DataSheetWidget, Action, Toolbar, session, state, { featureTogglesStore }, Nodes, xml, Query, { reject }, CareAndCompositionProductSalesRegionSwitchboard) {

	var STORAGE_KEY_TDS = "TDSProductSalesRegionURL";

	return declare(DataSheetWidget, {

		_resolveView: function () {
			// summary: update view configuration based on context

			// C8-4527: ProductSalesRegion selector on the CareAndComposition TDS view
			this.defView.defToolbar = lang.mixin(new Toolbar(), {
				m_actions: [
					lang.mixin(new SwitchboardAction(), {
						classToolbarPlugin: CareAndCompositionProductSalesRegionSwitchboard,
						m_id: "SelectProductSalesRegion",
						m_fixedQuery: new Query().Attr("Active", xml.OP_EQUALS, true),
						m_postAction: function () {
							this.widget.redraw();
							return true;
						}
					})
				]
			});

			const compositionFeatureFlagEnabled = featureTogglesStore.CAREANDCOMPOSITION_DATASHEET_USE_REACT_UI;
			const omitIds = {
				"Properties": compositionFeatureFlagEnabled,
				"PropertiesReact": !compositionFeatureFlagEnabled,
				"CareInstructions": compositionFeatureFlagEnabled,
				"CareInstructionsPerLanguage": compositionFeatureFlagEnabled,
				"CareIcons": compositionFeatureFlagEnabled,
				"CareIconsPerLanguage": compositionFeatureFlagEnabled,
				"CareInstructionsAndIcons": !compositionFeatureFlagEnabled,
				"BaseComposition": !compositionFeatureFlagEnabled,
				"CareBySalesRegion": !compositionFeatureFlagEnabled,
				"CompositionBySalesRegion": !compositionFeatureFlagEnabled,
				"CompositionPerLanguage": compositionFeatureFlagEnabled
			};
			this.defView.m_defs = reject(this.defView.m_defs, (view) => omitIds[view.m_id]);

			this.inherited(arguments);
		},

		redrawViews: function () {
			if (this.getChildView("CareInstructionsPerLanguage"))
				this.getChildView("CareInstructionsPerLanguage").redraw();
			if (this.getChildView("CareIconsPerLanguage"))
				this.getChildView("CareIconsPerLanguage").redraw();
			if (this.getChildView("CompositionPerLanguage"))
				this.getChildView("CompositionPerLanguage").redraw();
		},

		onViewCreate: function () {
			if (state.get("print") && !state.get("printAdHoc")) { // when printing get the product sales region from the url
				var url = session.getLocationValue("ProductSalesRegion");

				if (!xml.isValidURL(url)) {
					url = csi.EMPTY_URL;
				}

				this.set("activeProductSalesRegion", url);
			} else {
				this.set("activeProductSalesRegion", storage.get(STORAGE_KEY_TDS)); // get the product sales region from the storage
			}

			this.watch("activeProductSalesRegion", function (name, oldValue, newValue) {
				storage.set(STORAGE_KEY_TDS, newValue);
				this.redrawViews();
			});

			this.inherited(arguments);
		}

	});
});
